import axios from 'axios';
import { toastFlashMessage } from '../utils';

var axiosChatInstance = axios.create();
axiosChatInstance.defaults.baseURL = process.env.REACT_APP_BASE_CHAT_INTEGRATION;
axiosChatInstance.interceptors.request.use(
  function (config) {
    config['headers']['x-api-key'] = JSON.parse(localStorage.getItem('userInfo'))['chat_api_key'];
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosChatInstance.interceptors.response.use(
  function (response) {
    const apiStatus = response?.data?.status;

    if (apiStatus >= 200 && apiStatus < 300) {
      return response;
    }

    return response;
  },
  function (error) {
    const { response, config } = error;
    const showError = config?.showError !== false;

    if (response) {
      const apiStatus = response.data?.status;

      if ([400, 404, 422].includes(apiStatus)) {
        if (showError) {
          toastFlashMessage(response.data?.message, 'error');
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosChatInstance;
